import { useMemo } from 'react';

import { useAvailableChannels } from 'utils/channels';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { ConversationsStaticFilter } from '../static/conversationsStaticFilter';
import { ConversationsStaticFilterConfig } from '../static/conversationsStaticFilter.types';

/** Represents the component for filtering the conversations by channel. */
export const ConversationsChannelFilter = (): JSX.Element => {
  const flags = useFeatureFlag(['instagram-management']);
  const { availableChannels } = useAvailableChannels();

  const items = useMemo(
    (): readonly ConversationsStaticFilterConfig['channel'][] =>
      availableChannels
        // Instagram conversations appear as Facebook conversations
        .filter(({ channel }) =>
          channel === 'facebook_messenger' ? flags.instagramManagement : true,
        )
        .map(({ channel, icon, name }) => ({
          id: channel,
          icon,
          name,
        })),
    [availableChannels, flags.instagramManagement],
  );

  return <ConversationsStaticFilter type="channel" items={items} />;
};
